export default __webpack_public_path__ + "static/mp_open_house_2018_2-ec0cea2897e765ef8674ab8753c9a6b8.jpg";